export default defineNuxtPlugin(({ $config }) => {
  if ($config.public.BACKEND_URL?.includes('business')) {
    const { initialize } = useGtag();
    initialize('G-JZNBPZHDRX');
  }

  const companyStore = useCompanyStore();
  companyStore.applyIntegrations();
});